import React from 'react'

import './inputs.scss'

const Input = ({ title, id, register, classes, type }) => (
  <>
    <input
      className={`body ${classes || ''}`}
      placeholder={title}
      id={id}
      name={id}
      type={type}
      ref={register()}
    />
    {type === 'checkbox' && <label for={id}>{title}</label>}
  </>
)

const Checkbox = ({ title, id, register, checkboxClasses, labelClasses }) => (
  <div className="margin-bottom-medium">
    <span>
      <input
        className={checkboxClasses}
        placeholder={title}
        id={id}
        name={id}
        type="checkbox"
        ref={register()}
      />
      <label className={labelClasses} for={id}>
        {title}
      </label>
    </span>
  </div>
)

const TextArea = ({ title, id, register, classes }) => (
  <textarea className={classes} id={id} name={id} ref={register()} />
)

const Select = ({
  label,
  id,
  register,
  classes,
  type,
  options,
  multiple,
  errors,
}) => (
  <div className="select-container margin-bottom-large">
    <label className={`bold ${!errors[id] ? '' : 'error-text'}`} for={id}>
      {label}
    </label>
    <select
      className="body"
      id={id}
      name={id}
      ref={register()}
      multiple={multiple}
    >
    <option value="" disabled selected hidden>{label}</option>
      {options.map(option => (
        <option vale={option}>{option}</option>
      ))}
    </select>
  </div>
)

const RadioQuestion = ({ id, question, register, errors, options }) => (
  <div className="margin-bottom-large">
    <div
      className={`bold margin-bottom-small ${!errors[id] ? '' : 'error-text'}`}
    >
      {question}
    </div>
    {options.map(value => (
      <div className="margin-bottom-small">
        <input
          className="radio-button margin-right-small"
          ref={register()}
          type="radio"
          id={`${id}-${value}`}
          name={id}
          value={value}
        />
        <label for={id}>{value}</label>
      </div>
    ))}
  </div>
)

const SectionLabel = ({ label, validator }) => (
  <div
    className={`bold apply-section-label ${
      validator && validator() ? '' : 'error-text'
    }`}
  >
    {label}
  </div>
)

export { Input, Checkbox, TextArea, Select, RadioQuestion, SectionLabel }
